module.exports = __webpack_public_path__ + "img/ApprTemp3.9d03d10b.png";